<template>
    <page-layout :key="uuid" class="p-3">
        <b-skeleton v-if="loading" height="200px"></b-skeleton>
        <transition>
            <section v-if="!loading">
                <wishlist-wedding-header
                    v-if="wishlist?.type === 'wedding'"
                    is-public
                    :wishlist="wishlist"
                />
                <wishlist-header
                    v-else
                    is-public
                    :wishlist="wishlist"
                />
                <wishlist-details
                    v-if="wishlist"
                    is-public
                    :wishlist="wishlist"
                ></wishlist-details>
            </section>
        </transition>
    </page-layout>
</template>
<script>
import { defineComponent } from 'vue';
import WishlistDetails from '@components/Wishlist/WishlistDetails.vue';
import { useWishlistStore } from '@stores/Wishlist';
import PageTitle from '@components/Typography/PageTitle.vue';
import PageLayout from '@components/Layout/PageLayout.vue';
import WishlistWeddingHeader from '@components/Wishlist/Theme/WeddingHeader.vue';
import { useAppStore } from '@stores/App';
import WishlistHeader from '@components/Wishlist/Theme/WishlistHeader.vue';

export default defineComponent({
    components: { WishlistHeader, WishlistWeddingHeader, PageLayout, PageTitle, WishlistDetails },
    data() {
        const app = useAppStore();
        return {
            app: app,
            uuid: null,
            wishlist: null,
            loading: true,
        };
    },
    computed: {
        title() {
            return this.wishlist?.name ?? this.$t('wishlist.loading');
        },
    },
    mounted() {
        this.loading = true;
        this.uuid = this.$route.params.uuid;
        const wishlist = useWishlistStore();
        wishlist.getPublicList(this.uuid).then((res) => {
            this.app.setTheme(res.type);
            this.wishlist = res;
            this.loading = false;
        });
    },
    unmounted() {
        this.app.resetTheme();
    },
    methods: {},
});
</script>
<style scoped>
.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
